<template class=""  >
 <v-app id="voicetrackerval" >
    <v-flex blue >
          <v-toolbar flat dark class="mx-auto mb-4 blue">
                     <v-btn icon v-on:click.native="goBack()" > <v-icon>arrow_back</v-icon></v-btn>
            <v-toolbar-title class="headline">{{msg}}</v-toolbar-title>
          </v-toolbar>
          <v-flex xs8 mx-auto dark><date-select></date-select></v-flex>
          <vocal-act-log-instensity v-if=" (typeof actId !== 'undefined') && (typeof intensity === 'undefined' )" :postActId="actId"></vocal-act-log-instensity>
          <vocal-act-log-duration v-else-if=" (typeof actId !== 'undefined') && (typeof intensity !== 'undefined' ) && (typeof duration === 'undefined' )" :postIntensity="intensity" :postActId="actId"></vocal-act-log-duration>
          <vocal-act-log-notes v-else-if=" (typeof actId !== 'undefined') && (typeof intensity !== 'undefined' ) && (typeof duration !== 'undefined' )" :postIntensity="intensity" :postActId="actId" :postDuration="duration" ></vocal-act-log-notes>
          <vocal-act-log-type v-else ></vocal-act-log-type>
    </v-flex>
 </v-app>
</template>

<script>
import vocalActLogType from './ValType.vue'
import vocalActLogIntensity from './ValIntensity.vue'
import vocalActLogDuration from './ValDuration.vue'
import vocalActLogNotes from './ValNotes.vue'
import DateSelect from '../DateSelect.vue'

export default {
  data () {
    return {
      msg: 'Log Voice Activity',
    }
  },
  components: {
            'vocal-act-log-type': vocalActLogType,
            'vocal-act-log-instensity': vocalActLogIntensity,
            'vocal-act-log-duration': vocalActLogDuration,
            'vocal-act-log-notes': vocalActLogNotes,
            'date-select': DateSelect
  },
  methods: {
    goBack(){ this.$router.back(); }
  },
  props: [
    'actId',
    'intensity',
    'duration',
  ]
}

</script>









// WEBPACK FOOTER //
// src/components/val/Val.vue